// Textos do painel do SGP. Ficam aqui, e não nos locale/*.json do Chatwoot,
// para não virar conflito a cada atualização. Cada componente carrega com
// `useI18n({ messages })`. O produto é brasileiro: o texto em português vale
// também para quem usa o Chatwoot em inglês.

const PT = {
  NEUXS_SGP: {
    TITULO: 'SGP',
    CONSULTANDO: 'Consultando o SGP…',
    TENTAR_DE_NOVO: 'Tentar de novo',
    ATUALIZAR: 'Atualizar',
    COPIAR: 'Copiar',
    COPIADO: 'Copiado',
    SEM_CONFIGURACAO:
      'O SGP está ligado para esta empresa, mas ainda sem servidor e credencial. Peça ao administrador da instalação para cadastrar.',
    ERRO_GENERICO: 'Não consegui falar com o SGP.',
    ABAS: {
      FINANCEIRO: 'Financeiro',
      SUPORTE: 'Suporte',
      MANUTENCAO: 'Manutenção',
    },
    DOCUMENTO: {
      EXPLICA:
        'Este cliente ainda não tem CPF/CNPJ cadastrado. Sem ele não dá para consultar o SGP.',
      PLACEHOLDER: '000.000.000-00',
      SALVAR: 'Salvar',
      TROCAR: 'Trocar documento',
      ERRO: 'Não consegui salvar o documento.',
    },
    CONTRATO: {
      BUSCANDO: 'Buscando contratos…',
      INDISPONIVEL: 'Contratos indisponíveis',
      NENHUM: 'Nenhum contrato no SGP',
      UNICO: 'Contrato {id}',
      SELECIONE: 'Selecione o contrato',
      ERRO: 'Não consegui salvar o contrato.',
    },
    FINANCEIRO: {
      VENCIDOS: 'vencidos',
      A_VENCER: 'a vencer',
      A_COBRAR: 'a cobrar',
      POR_CONTRATO: 'Contrato {contrato}',
      POR_DOCUMENTO:
        'Todos os contratos do CPF: escolha um contrato para separar os boletos.',
      EM_ABERTO: 'Em aberto',
      TODOS: 'Todos',
      NENHUM_ABERTO: 'Nenhum boleto em aberto. Cliente em dia.',
      NENHUM: 'Nenhum boleto encontrado.',
      VENCIMENTO: 'Venc. {data}',
      ATRASO: '{dias} dia(s) em atraso',
      PAGO_EM: 'Pago em {data}',
      ORIGINAL: 'Valor original {valor} + encargos',
      MOSTRANDO: 'Mostrando {parcial} de {total} títulos.',
      STATUS: {
        aberto: 'Em aberto',
        vencido: 'Vencido',
        pago: 'Pago',
        cancelado: 'Cancelado',
        outro: 'Outro',
      },
      BOTAO: 'Boleto com botão',
      PDF: 'Enviar PDF',
      PIX: 'Pix com botão',
      LINK: 'Enviar o link',
      COPIAR_LINHA: 'Copiar a linha digitável',
      COPIAR_PIX: 'Copiar o Pix copia e cola',
      ABRIR: 'Abrir o boleto',
      ENVIADO: 'Enviado',
      ERRO_ENVIO: 'Não consegui enviar o boleto.',
      TEXTO_LINK:
        'Segue o boleto com vencimento em {data}, no valor de {valor}.\n\n{link}',
      PROMESSA: {
        TITULO: 'Promessa de pagamento',
        PAGAR_ATE: 'Pagar até',
        LANCAR: 'Lançar promessa',
        LIBERADO: 'Liberado',
        NAO_LIBERADO: 'O SGP não liberou',
        RESUMO: 'Até {data} · {dias} dia(s) · protocolo {protocolo}',
        ERRO: 'Não consegui lançar a promessa.',
      },
    },
    SUPORTE: {
      CONECTADO: 'Conectado',
      SEM_CONEXAO: 'Sem conexão',
      HA: 'há {tempo}',
      DESDE: 'desde {momento}',
      SINAL: 'Sinal óptico',
      ONU_RECEBE: 'ONU recebe',
      OLT_RECEBE: 'OLT recebe',
      TOM: {
        bom: 'Bom',
        atencao: 'Atenção',
        ruim: 'Ruim',
        neutro: 'Sem leitura',
      },
      CONEXAO: 'Conexão',
      CONTRATO: 'Contrato {id}',
      CLIENTE: 'Cliente',
      ENDERECO: 'Endereço',
      NESTA_SESSAO: 'nesta sessão',
      NENHUM: 'Nenhum serviço neste contrato.',
      CAMPOS: {
        SERIAL: 'Serial',
        OLT: 'OLT / slot / PON',
        MEDIDO: 'Medido em',
        LOGIN: 'Login',
        IP: 'IP',
        IPV6: 'IPv6',
        MAC: 'MAC',
        PLANO: 'Plano',
        NAS: 'Concentrador',
        PORTA: 'Porta',
        SITUACAO: 'Situação desde',
        CADASTRO: 'Cliente desde',
        POP: 'POP',
        NOME: 'Nome',
        TELEFONE: 'Telefone',
        EMAIL: 'E-mail',
        LOCAL: 'Local',
        CIDADE: 'Cidade',
        REFERENCIA: 'Referência',
        COORDENADAS: 'Coordenadas',
      },
    },
    MANUTENCAO: {
      NENHUMA: 'Nenhuma manutenção cadastrada.',
      FASE: {
        agora: 'Em andamento',
        programada: 'Programada',
        encerrada: 'Encerrada',
        inativa: 'Desativada',
      },
      TODOS_OS_POPS: 'Todos os POPs',
      FINALIZAR: 'Encerrar',
      FINALIZADA: 'Manutenção encerrada.',
      NOVA: 'Nova manutenção',
      CANCELAR: 'Cancelar',
      CADASTRAR: 'Cadastrar',
      CADASTRADA: 'Manutenção cadastrada.',
      DESCRICAO: 'Descrição',
      INICIO: 'Início',
      FIM: 'Término',
      STATUS: 'Status',
      MENSAGEM: 'Mensagem na central do assinante',
      POPS: 'POPs afetados',
      AVISO:
        'Cadastrar publica: a mensagem aparece para os clientes na central. O SMS fica desligado.',
      STATUS_OPCOES: {
        0: 'Desconhecido',
        1: 'Investigando',
        2: 'Identificado',
        3: 'Observando',
        4: 'Resolvido',
      },
    },
  },
};

export default { pt_BR: PT, en: PT };
